<template>
    <div class="row" id="post-container">
        <EventBlockItem v-for="item in items" :data="item" :userid="this.userid"></EventBlockItem>
    </div>
</template>

<script>

import EventBlockItem from './EventBlockItem';

export default {

    data () {
        return {
            //
        }
    },

    created () {
        //
    },

    components: {
        EventBlockItem
    },

    props: ['items', 'userid'],

}
</script>